import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IMerchantGetHashPasswordRequest{
    merchantId:number;
}

async function getMerchantHash(data:IMerchantGetHashPasswordRequest):Promise<any> {
    try {
        const response=await axiosInstance.post(`/Merchant/GetHash?merchantId=${data.merchantId}`);
        return response.data
        
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
    
}


export function useGetHashMerchant(){
    return useMutation<any, Error, IMerchantGetHashPasswordRequest>((variables) =>
    getMerchantHash(variables)
  );
}